import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateContactAutocomplete } from './useContactAutocomplete';
import { invalidateAllContactFilterQueries } from './useContactFilterQuery';

export const useCreateContactMutation = ({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (contact: Api.IContact) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ firstName, lastName, email }: { firstName?: string; lastName?: string; email?: string }) =>
			userSession.webServiceHelper.callAsync<Api.IContact>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: 'contact' }),
				'POST',
				{
					firstName,
					lastName,
					emailAddresses: email ? [{ value: email }] : undefined,
				}
			),
		onError,
		onSuccess: (contact: Api.IContact) => {
			invalidateContactAutocomplete();
			invalidateAllContactFilterQueries();
			onSuccess?.(contact);
		},
	});
};
